import { render, staticRenderFns } from "./SimpleImageDetailDlg.vue?vue&type=template&id=fed61ba8"
import script from "./SimpleImageDetailDlg.vue?vue&type=script&lang=js"
export * from "./SimpleImageDetailDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports